function initColorSwiper() {
  const containers = document.querySelectorAll(".products-container-custom");
  if (!containers.length) return;

  if (typeof Swiper === "undefined") {
    setTimeout(initColorSwiper, 300);
    return;
  }

  containers.forEach((container) => {
    const el = container.querySelector(".color-swiper");
    if (!el) return;

    // Prevent duplicate init
    if (el.swiper) return;

  new Swiper(el, {
  loop: true,
  spaceBetween: 8,
  slidesPerView: 6, // default desktop

  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  },

  navigation: {
    nextEl: container.querySelector(".swiper-button-next"),
    prevEl: container.querySelector(".swiper-button-prev"),
  },

  watchOverflow: true,

  breakpoints: {
    0: { slidesPerView: 4 },
    768: { slidesPerView: 5 },
    1024: { slidesPerView: 6 }
  },
});
  });
}

// Try after DOM ready
document.addEventListener("DOMContentLoaded", initColorSwiper);

// Also try after full page load (catches deferred Swiper)
window.addEventListener("load", initColorSwiper);

// Shopify section reload
document.addEventListener("shopify:section:load", initColorSwiper);